module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "preface",
    attrs: {
      "id": "itr"
    }
  }, [_c('h1', {
    staticClass: "chapter"
  }, [_c('a', {
    attrs: {
      "id": "pagexii"
    }
  }), _c('a', {
    attrs: {
      "id": "pagexiii"
    }
  }), _c('em', [_vm._v("FOREWORD")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "big"
  }, [_vm._v("T")]), _vm._v("he first time I watched the Blue Angels perform, I was a plebe at the United States Naval Academy. They flew overhead in their shiny new Bearcats to put on a show. Wow! So this is what naval aviation is all about. I often wondered how many young men were influenced by the spectacular showmanship of the navy’s best aviators to become pilots themselves.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("To be a naval aviator is a unique experience. To fly with the Blue Angels is a cherished assignment and a recognition of superb flying skills— but to be the leader of the “Blues” is the ultimate achievement in flying ability: the best of the best. Such a naval aviator was Roy Marlen “Butch” Voris—the First Blue.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This book relates the fascinating aeronautical life of Butch Voris. He was a World War II ace, flying Hellcats against the Japanese. There he learned his acrobatic skills dogfighting with the enemy. He was a natural to head up the navy’s first acrobatic flying team. His excellent leadership developed a team of aviators that were the best in the world.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In these pages you will learn about his close calls and crashes; his teammates; the transition from props to jets; Washington politics; his experience at Grumman Aircraft; and finally, finishing his career with NASA.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("When you open the pages of this book, you will be flying with the "), _c('a', {
    attrs: {
      "id": "pagexiv"
    }
  }), _vm._v("leader of the “Blues.” Fasten your seatbelt. The “air show” is about to begin.")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v("James A. Lovell")]), _vm._v(" "), _c('p', {
    staticClass: "right1"
  }, [_vm._v("(Captain, U.S. Navy, Ret.,"), _c('br'), _vm._v("and former NASA Astronaut)")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-715a4254","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/9780312322496_epub_itr_r1.vue
// module id = 81
// module chunks = 0